import { privateApi } from 'services';
import { ContentTag, ContentTagsConfig, CreateContentTagsConfig } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchContentTags = async (businessAccountId: string): Promise<ContentTag[]> =>
    privateApi.get<ContentTag[]>(`business-accounts/${businessAccountId}/content-library/tags`);

const createContentTagsConfig = async (
    selectedBusinessAccountId: string,
    values: CreateContentTagsConfig,
): Promise<ContentTag> =>
    privateApi.post<ContentTag>(`business-accounts/${selectedBusinessAccountId}/content-library/tags`, values);

const updateContentTagsConfig = async (
    itemId: string,
    contentTagsConfig: ContentTagsConfig,
): Promise<ContentTagsConfig> =>
    privateApi.put<ContentTagsConfig>(`content-library/content-item-tags-configs/${itemId}`, contentTagsConfig);

const updateContentTagStatus = async (itemId: string, enabled: boolean): Promise<ContentTagsConfig> =>
    privateApi.put<ContentTagsConfig>(`content-tags/${itemId}/status`, {
        enabled,
    });

export const ContentTagsConfigGateway = {
    fetchContentTags,
    createContentTagsConfig,
    updateContentTagsConfig,
    updateContentTagStatus,
};

const cancelableFetchContentTags = (businessAccountId: string): Promise<ContentTag[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<ContentTag[]>(
        `business-accounts/${businessAccountId}/content-library/tags`,
    );

export const CancelableContentTagsConfigGateway = {
    cancelableFetchContentTags,
};
